// extracted by mini-css-extract-plugin
module.exports = {"Title":"UploadContentBankItem_Title__2LhCy","TitleText":"UploadContentBankItem_TitleText__1Q6AG","CloseBtn":"UploadContentBankItem_CloseBtn__1D_gH"};